export const Logo = ({ variant = "dark", className = "h-11" }) => (
  <a href="#home" data-testid="brand-logo" aria-label="ZIRSEN" className="inline-flex items-center">
    <img
      src={variant === "light" ? "/logo-light.png" : "/logo-dark.png"}
      alt="ZIRSEN — Finance & Pojištění & Investice"
      className={`w-auto ${className}`}
    />
  </a>
);
